<template>
    <div 
    draggable 
    @drop="taskDroppedOnTask($event, worker, task)" 
    @dragstart="startDrag($event, task, worker)"
    style="position: absolute; z-index: 99; font-size: small; border: 2px solid; overflow: hidden;"
    v-bind:class="{ 'intervention': task.typeof == 'intervention', 'inspection': task.typeof == 'inspection', 'installation': task.typeof == 'installation', 'other': task.typeof == 'other', 'circle': selectedWorkers.indexOf(worker.value) == -1, 'task': selectedWorkers.indexOf(worker.value) != -1, 'notending': date.isSame(task.endsAt, 'day') == false, 'notstarting': date.isSame(task.startsAt, 'day') == false, 'taskfinished': (task.status == 'finished_worker' | task.status == 'finished' | task.status == 'cancelled' | task.status == 'cleared' | task.status == 'refused')}"
    v-bind:style="{ top:  '' + getTimeFraction(task.startsAt) + 'px' , left: 'calc(' + getTaskOffset(index) + 'px )', height: 'calc('+  (selectedWorkers.indexOf(worker.value) == -1  ? '30' : getTaskLength(task)) +'px )', cursor: 'move'}"
    @dblclick="showTask(task)"
    @dragover.prevent
    @dragenter.prevent
    v-on:click="shuffleTask(task, worker.value)"
    :itemId="task.id" :workerId="worker.value">
        <div style="cursor: ns-resize; height:10%; position: absolute; top: 0; width: 95%;" @mousemove="resizingUp = true" @mouseleave="exitResizingUp()" v-if="selectedWorkers.indexOf(worker.value) > -1"></div>
        <template v-if="selectedWorkers.indexOf(worker.value) != -1">
            <p style="font-weight: bold;margin: 0px;text-transform: uppercase;" :key="task.id">
                <template v-if="date.isSame(task.startsAt, 'date')">
                    {{task.startsAt | formatHour}}
                </template><template v-else> {{task.startsAt | formatDateWithHour}}</template> - <template v-if="date.isSame(task.endsAt, 'date')">
                    {{task.endsAt | formatHour}}
                </template><template v-else> {{task.endsAt | formatDateWithHour}}</template>
                <b>
                    <template v-if="task.typeof == 'inspection' || task.typeof == 'installation'">{{tasksnames[task.typeof]}}</template>
                    <template v-if="task.typeof == 'intervention'">{{intervention_types[task.intervention_type]}}</template>
                    <template v-if="task.typeof == 'other'">{{task.typeof_other}}</template>
                </b>
            </p>
            <p style="margin-top: 5px; margin-bottom: 5px;">
                <template v-if="task.address != undefined"><b>{{[task.address.street, task.address.city].filter(v=>v!='').join(", ")}}</b></template>
                <template v-if="task.place_id != undefined"><b>{{placesdict[task.place_id]}}</b></template>
            </p>
            U: {{task.name}}
        </template>
        <template v-if="selectedWorkers.indexOf(worker.value) == -1">
            {{worker.symbol}}
        </template>
        <div style="cursor: ns-resize; height:10%; position: absolute; bottom: 0; width: 95%;" @mousemove="resizingDown = true" @mouseleave="exitResizingDown()" v-if="selectedWorkers.indexOf(worker.value) > -1"></div>
    </div>
</template>
<script>
export default {
  props: {
    task: Object,
    workerId: [Number, String],
    draggingTaskId: [Number, String],
    selectedWorkers: Array,
    placesdict: Object,
  },
  computed: {
    taskClasses() {
      const classes = [this.task.typeof, 'task'];
      if (this.selectedWorkers.indexOf(this.workerId) === -1) classes.push('circle');
      else classes.push('task');
      if (['finished', 'finished_worker', 'cancelled', 'cleared', 'refused'].includes(this.task.status)) classes.push('taskfinished');
      return classes;
    },
    taskStyles() {
      return {
        top: this.task.topPx + 'px',
        height: this.task.heightPx + 'px',
        cursor: 'move',
      };
    },
    showDetails() {
      return this.selectedWorkers.indexOf(this.workerId) !== -1;
    },
    canResizeTop() {
      return this.selectedWorkers.indexOf(this.workerId) !== -1;
    },
    canResizeBottom() {
      return this.selectedWorkers.indexOf(this.workerId) !== -1;
    },
    taskLabel() {
      // You can replicate your template logic here (times, intervention types, etc.)
      return `${this.task.startsAt} - ${this.task.endsAt} ${this.task.typeof}`;
    }
  },
  methods: {
    onDragStart(event) {
      this.$emit('dragstart', event, this.task, this.workerId);
    },
  },
};
</script>

<style scoped>
.resizer {
  position: absolute;
  width: 95%;
  height: 10%;
  cursor: ns-resize;
}
.resizer.top { top: 0; }
.resizer.bottom { bottom: 0; }
</style>